import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "category", "group", "variable", "empty", "destination"]
  static values = { category: { type: String, default: "" } }

  reset(field) {
    this.searchTarget.value = ""
    this.categoryValue = ""
    this.destinationTarget.textContent = `Insert into ${field === "subject" ? "subject" : "message"}`
    this.filter()
    this.groupTargets[0]?.parentElement.scrollTo(0, 0)
  }

  selectCategory(event) {
    this.categoryValue = event.params.category
    this.filter()
  }

  filter() {
    const terms = this.searchTarget.value.trim().toLocaleLowerCase().split(/\s+/)

    this.categoryTargets.forEach(button => {
      button.setAttribute("aria-pressed", String(button.dataset.templateVariablesCategoryParam === this.categoryValue))
    })

    this.groupTargets.forEach(group => {
      const matchesCategory = !this.categoryValue || group.dataset.category === this.categoryValue
      const buttons = this.variableTargets.filter(button => group.contains(button))

      buttons.forEach(button => {
        const text = button.textContent.toLocaleLowerCase()
        button.hidden = !matchesCategory || !terms.every(term => text.includes(term))
      })

      group.hidden = buttons.every(button => button.hidden)
    })

    this.emptyTarget.hidden = this.groupTargets.some(group => !group.hidden)
  }

  insert(event) {
    const source = event.params.source ?? `{{ ${event.params.key} }}`
    this.dispatch("insert", { detail: { source } })
  }

  closed() {
    this.dispatch("closed")
  }
}
